document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (!button || !menu) return;

  button.addEventListener('click', function () {
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', String(!isOpen));
    menu.classList.toggle('mobile-menu-open', !isOpen);
  });
});